// A panel that is open (a form, a question) is a flag in the URL, written with replace: opening and closing it
// are not history steps, and Back returns to the page with the panel as it was.

export const flagOn = (p: URLSearchParams, key: string): boolean => p.get(key) === '1';

/** The parameters with the flag set or removed; everything else stays. */
export function withFlag(p: URLSearchParams, key: string, on: boolean): URLSearchParams {
  const out = new URLSearchParams(p);
  if (on) out.set(key, '1'); else out.delete(key);
  return out;
}

/** The parameters with one value set, or removed when empty. */
export function withParam(p: URLSearchParams, key: string, value: string | undefined): URLSearchParams {
  const out = new URLSearchParams(p);
  if (value) out.set(key, value); else out.delete(key);
  return out;
}
